import { IInventoryPage } from '../../../inventory-page.interface';


export const RESEARCH_ADVERTISEMENT_AD_LISTS_PAGE: IInventoryPage = {
	'route': '/research/advertisement/ad-lists',
	'title': 'Ad Lists',
	'uiReference': [
		'Open advertising list actions',
		'Product List Workspace',
		'products',
		'Open in Search',
		'Save',
		'Export lists',
		'Upcoming events',
		'Ad Lists',
		'Info',
		'Statistics',
		'Interest Over 5 Years',
		'Keyword List',
		'Negative Keywords',
		'Create Your Advertising Keywords List!',
		'Saved Ad Lists',
		'New List',
		'Edit Advertising List',
		'Saved advertising lists',
		'Import',
		'Export',
		'Filter',
		'&middot;',
		'&ndash;',
		'Name',
		'Add campaign context or notes for this product list',
		'New Keywords (Separate by comma tag1, tag2,...)',
		'Details',
		'Notes',
		'Marketplace',
		'Date',
		'Products',
		'Select a product to manage its advertising keywords and targets.',
		'Amazon Search Volume',
		'Google Search Volume',
		'Keywords',
		'Add keywords',
		'Separate multiple keywords with commas.',
		'Add',
		'Targeting',
		'Empty Advertisement List',
		'Advertising products',
		'more keywords available,',
		'show all available keywords',
		'viewing of all available keywords not included in Free Version',
		'Loading...',
		'Not enough data.'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/advertisement/ad-lists/ad-lists-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/advertisement/ad-lists/ad-lists.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/advertisement/ad-lists/ad-lists.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/advertisement/ad-lists/ad-lists.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/info-card/info-card.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/info-card/info-card.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/advertisement/ad-lists/sub-components/ad-lists-menu/ad-lists-menu.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/advertisement/ad-lists/sub-components/ad-lists-menu/ad-lists-menu.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/advertisement/ad-lists/sub-components/ad-list-edit/ad-list-edit.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/advertisement/ad-lists/sub-components/ad-list-edit/ad-list-edit.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/advertisement/ad-lists/sub-components/ad-list-edit/ad-list-edit.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/advertisement/ad-lists/sub-components/mba-product-select/mba-product-select.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/advertisement/ad-lists/sub-components/mba-product-select/mba-product-select.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/statistics-and-charts/search-volume-chart/sub-components/amazon-sv-chart/amazon-sv-chart.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/statistics-and-charts/search-volume-chart/sub-components/amazon-sv-chart/amazon-sv-chart.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/statistics-and-charts/search-volume-chart/sub-components/google-sv-chart/google-sv-chart.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/statistics-and-charts/search-volume-chart/sub-components/google-sv-chart/google-sv-chart.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-container/kw-table/kw-table.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-container/kw-table/kw-table.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/chart/chart.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/chart/chart.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/statistics-and-charts/search-volume-chart/sub-components/empty-sv/empty-sv.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/statistics-and-charts/search-volume-chart/sub-components/empty-sv/empty-sv.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-container/kw-table/kw-table-row/kw-table-row.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-container/kw-table/kw-table-row/kw-table-row.component.html'
	],
	'aliases': [
		'Advertising Lists'
	]
};
